import { render } from "./HomeCta.vue?vue&type=template&id=0a351c32&scoped=true&bindings={}"
import script from "./HomeCta.vue?vue&type=script&lang=js"
export * from "./HomeCta.vue?vue&type=script&lang=js"

import "./HomeCta.vue?vue&type=style&index=0&id=0a351c32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a351c32"

export default script